export default __webpack_public_path__ + "static/media/closempin.e0d9df35.svg";